<sales-loader [@fadeInOut] *ngIf="loading$ | async"></sales-loader>
<sales-header
  [homeNavigationLink]="config.header.home"
  [navigationLinks]="headerNavigationLinks"
></sales-header>
<main>
  <sales-welcome-back-message
    *ngIf="isCheckoutPage"
    [personalDetails]="userProfileFacade.personalDetails$ | async"
  ></sales-welcome-back-message>
  <ui-progress-tracker-route-based
    [steps]="progressSteps$ | async"
    [currentRoute]="currentRoute"
  ></ui-progress-tracker-route-based>
  <router-outlet></router-outlet>
</main>
<sales-footer></sales-footer>
